import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { OWNERSHIP_CHANGE_PACKET } from "./apiRoutes";

interface UseGetOwnershipChangePacketByCommunityProps {
  communityId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getOwnershipChangePacketByCommunity = async (communityId: string) =>
  await axiosAuth.get(`${OWNERSHIP_CHANGE_PACKET}/community/${communityId}`);

const useGetOwnershipChangePacketByCommunity = ({
  communityId,
  queryParams,
}: UseGetOwnershipChangePacketByCommunityProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["ownership-change-packet-community", communityId],
    queryFn: () => getOwnershipChangePacketByCommunity(communityId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    enabled: !!communityId,
    ...queryParams,
  });
};

export default useGetOwnershipChangePacketByCommunity;
